<template>
    <!--所属店铺下拉接口-->
    <el-select v-model="storeId"  multiple collapse-tags :placeholder="placeholder" :size="size"
               @visible-change="visiblechange" @change="change">
        <el-option
                v-for="item in list"
                :key="item.storeId"
                :label="item.storeName"
                :value="item.storeId">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        name: "all-store-list",
        props: {
            size: String,
            placeholder: String,
            required: Boolean,
            // multiple: Boolean,
            // clearable: Boolean,
            value: [Array, Object, String],
        },
        model: {
            prop: 'value',
            event: 'input'
        },
        data() {
            return {
                list: [],
                oldstoreId: ['all'],
                storeId: ['all'],
                multiple: false,
            }
        },
        watch: {
            value(newval, oldval) {
                console.log(newval)
                this.storeId = newval;

            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                this.$axios.post('/store/dropDownBox').then(res => {
                    this.list = res.data.list;
                    this.list.unshift({storeName: '全部门店', storeId: 'all'});
                    this.change(this.storeId);
                }).catch(err => {
                    this.$message.error(err.msg)
                })
            },
            visiblechange(isshow) {
                console.log(isshow)
                if (isshow) {
                    this.getData();
                }
            },
            checkedList(value){
                var a = [], newval = [];
                console.log(value.indexOf('all'))
                if ((value.indexOf('all')) > -1 || ((value.indexOf('all')) <= -1 && value.length == this.list.length - 1)) {
                    newval.push('all');
                    for (var i = 0, len = this.list.length; i < len; i++) {
                        if (this.list[i].storeId != 'all') {
                            newval.push(this.list[i].storeId)
                        }
                    }
                } else {
                    newval = value;
                }
                this.list.filter((item) => {
                    for (var i in newval) {
                        if (item.storeId == newval[i]) {
                            a.push(item);
                            break;
                        }
                    }
                });
                console.log(newval)
                this.$emit('input', newval)
                this.$emit('change', a);
            },
            change(value) {
                console.log(value)
                this.checkedList(value);

            }
        }
    }
</script>

<style scoped>

</style>